import { render } from "./customerOfferDetails.vue?vue&type=template&id=c7f78904&scoped=true"
import script from "./customerOfferDetails.vue?vue&type=script&lang=js"
export * from "./customerOfferDetails.vue?vue&type=script&lang=js"

import "./customerOfferDetails.vue?vue&type=style&index=0&id=c7f78904&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f78904"]])

export default __exports__